import zhLocale from "element-ui/lib/locale/lang/zh-CN";
const cn = {
  message: {
    tips: "提示",
    privacyPolicy: '隐私政策',
    terms: '服务条款',
    systemWorking: '系统运行正常',
    // 头部
    header: {
      firstNav1: '产品',
      firstNav2: '场景',
      firstNav3: '行业解决方案',
      firstNav4: '关于我们',
      sceneLabel1: '供应链管理（含集装箱堆场）',
      sceneLabel2: '原料外仓管理',
      sceneLabel3: '园区管理',
      sceneLabel4: '月台管理',
      sceneLabel5: '装卸车及入库',
      sceneLabel6: '配送搬运',
      sceneLabel7: '成品外仓管理',
      sceneLabel8: '生产过程管理',
      sceneLabel9: '拣选备货',
      sceneLabel10: '存储与理货',
      sceneLabel11: '安全防护与运营规范管理',
      sceneLabel12: '设备巡检运维管理',
      sceneLabel13: '资产管理',
      sceneLabel14: '人员管理',
      sceneLabel15: '车辆管理',
      sceneDesc1: '全链路数智化管控，降本增效提柔性',
      sceneDesc2: '原料仓储智能管理，优化库存提周转',
      sceneDesc3: '原料仓储智能管理，优化库存提周转',
      sceneDesc4: '月台作业智能调度，提升装卸效率',
      sceneDesc5: '装卸入库数字化，操作高效零失误',
      sceneDesc6: '配送搬运智能调度，减少资源闲置',
      sceneDesc7: '成品外仓精细化管理，安全提效',
      sceneDesc8: '生产数据实时监测，动态优化生产',
      sceneDesc9: '精准拣选智能备货，保障交付时效',
      sceneDesc10: '智能存储理货，提升空间利用率',
      sceneDesc11: '全流程安全管控，规范运营保品质',
      sceneDesc12: '设备智能巡检，降低故障停线风险',
      sceneDesc13: '资产全生命周期追踪，提升利用效率',
      sceneDesc14: '人员智能调度，优化人力成本投入',
      sceneDesc15: '车辆统筹管控，提高运营使用效率',
      
      secondProductNav1: '智能软件',
      secondProductNav2: '智能装备',
      secondProductNav3: '智能IoT硬件',
      productLabel1: 'Wisdom - AI人工智能',
      productLabel2: 'Wisdom - BI分析与数字孪生',
      productLabel3: '业务管理系统',
      productLabel4: 'Noah智能硬件/设备连接控制平台',
      productLabel5: '物流自动化',
      productLabel6: 'AI机器人',
      productLabel7: '穿戴式设备',
      productLabel8: '物流车辆状态自采集设备',
      productLabel9: '高精度定位设备',
      productLabel10: '无纸化显示、一键更新设备',
      productLabel11: '快速盘点、批量扫描设备',
      productLabel12: '智能亮灯指引设备',
      productLabel13: '无人值守设备',
      productLabel14: '工器具流转跟踪设备',
      productLabel15: '快速呼叫设备',
      productLabel16: '信息·身份·数量识别感知设备',
      productLabel17: '作业指引及防错提示类设备',
      productLabel18: '跟随机器人',
      productLabel19: '安全防护类设备',
      productLabel20: '行李/大件物品识别及扫描设备',
      productDesc1: 'AI 赋能运营，实现智能调度与自主优化',
      productDesc2: '数据可视化分析，数字孪生实时管控',
      productDesc3: '全业务数字化管控，提效降本增柔性',
      productDesc4: '设备全周期智管，降低故障提升利用率',
      productDesc5: '全流程自动化作业，降本增效提产能',
      productDesc6: 'AI 智能机器人作业，精准协同提效率',
      productDesc7: '便携穿戴互联，实现人员实时管控',
      productDesc8: '车辆状态自动采集，动态监控全流程',
      productDesc9: '精准定位人事物，实时追踪无盲区',
      productDesc10: '无纸化智能显示，一键更新高效便捷',
      productDesc11: '批量扫描快速盘点，提升仓储作业效率',
      productDesc12: '亮灯智能指引，拣选备货精准高效',
      productDesc13: '全程无人值守，实现作业自动化运行',
      productDesc14: '工器具全流程跟踪，提升周转利用率',
      productDesc15: '一键快速呼叫，高效响应现场需求',
      productDesc16: '智能感知识别，全维度采集核心数据',
      productDesc17: '实时指引作业，精准防错降失误率',
      productDesc18: '智能随行避障，高效省心助力生产',
      productDesc19: '全方位安全防护，精准预警隐患，保障作业安全',
      productDesc20: '精准扫描识别行李与大件物品，高效核验',

      industryName1: '汽车',
      industryName2: '装备制造',
      industryName3: '电子电器',
      industryName4: '航空航天',
      industryName5: '汽配',
      industryName6: '生物医疗',
      industryName7: '图书电商及其他物流',
      industryName8: '交通运输服务',
      industryName9: '工程机械',
      industryName10: '食品烟草日化',
      industryName11: '化工',
      industryName12: '市政公共服务',
      industryName13: '白色家电',
      industryName14: '冶炼冶金',
      industryName15: '高铁制造',
      industryName16: '医疗服务',
      industryTitle: '行业方案',

      news: '新闻动态',
    },
    // 底部
    footer: {
      title: '联系我们，立即为您定制最佳ROI解决方案',
      contactBtn: '立即联系',
      slogan: 'TBL华清科盛始终以“让运营因智慧而简单”为己任，专注科技研发和场景应用，引领场域全要素的“数智化”变革。',
      label1: '产品-智能软件',
      label2: '产品-智能装备',
      label3: '产品-智能IoT硬件',
      label4: '场景',
      label5: '行业场景方案',
      label6: '关于我们',
      contactUs: '联系我们',
      hotline: '全国统一服务热线',
      address: '北京市亦庄经济技术开发区<br/>大族广场T6-3层',
      address2: '上海 | 广州 | 苏州 | 常州 | 武汉 | <br/> 新加坡',
      msg1: '关注官方公众号',
      msg2: '获取最新行业资讯',
      more: '了解更多',
      sloganMsg1: '<span style="font-weight: 600;">免费获得</span>一次线上初步场景分析与建设方向建议',
      sloganMsg2: '<span style="font-weight: 600;">免费获取</span>一次业务场景初步评估与数智化建设建议',
      sloganBtnText1: '免费获取',
    },
    // 行业
    industry: {
      industryTitle: '应用行业',
      industryName1: '汽车行业',
      industryName2: '汽配行业',
      industryName3: '工程机械',
      industryName4: '白色家电',
      industryName5: '装备制造',
      industryName6: '生物医疗',
      industryName7: '食品烟草日化',
      industryName8: '冶炼冶金',
      industryName9: '电子电器',
      industryName10: '图书电商及其<br/>他物流',
      industryName11: '化工行业',
      industryName12: '高铁制造',
      industryName13: '航空航天',
      industryName14: '交通运输',
      industryName15: '市政公共服务',
      industryName16: '医疗服务',
    },
    // 首页
    index: {
      banner: {
        title: `现场要素<span style="color: #206DE2">全域协同，<br/>智能连接、控制、分析与优化</span>，<br/>打造AI实时动态优化运营体系。`,
        subTitle: '人/车/机/物/场/器 全要素loT硬件赋能+AI优化大脑，<br/>助力企业精益化运营',
        btnText: '立即联系',
        fillEmail: '填写您的邮箱',
        desc: "通过提交此表单，您同意我们的使用条款、隐私政策，并同意接收来自我们的营销通讯。",
      },
      plate: {
        title: '七大核心板块，软硬协同，共筑数智新蓝图',
        platform1: 'Wisdom-AI人工智能',
        platform2: 'Wisdom-BI分析与数字孪生',
        platform3: '业务管理系统',
        platform4: 'Noah智能硬件/设备连接控制平台',
        platform5: '智能IoT硬件',
        platform6: 'AI机器人 ',
        platform7: '物流自动化',
        desc1: '智慧 AI 全流程运营，<br/>智能分析与优化',
        desc2: '数字孪生赋能，<br/>实时可视智能分析',
        desc3: '多系统一体化，全流程业务管控',
        desc4: '设备互联互通，统一管控的智能中间件平台',
        desc5: '全栈智能硬件装备，<br/>适配多行业场景',
        desc6: 'AI 驱动智能机器人，<br/>全场景自动化作业',
        desc7: '全流程自动化，<br/>提质增效降本',
      },
      solution: {
        title: '生产/物流/资产/安全——运营全场景解决方案',
        scene: '场景',
      },
      enterprise: {
        title: 'TBL已服务超500+年产值“过百亿”的大型企业',
        subTitle1: '中国品牌',
        desc1: '携手国内头部企业，共筑产业数字化新生态',
        subTitle2: '国际品牌',
        desc2: '布局海外市场，服务全球产业数字化升级',
      }
    },
    // 关于我们
    about: {
      title: '科技创新的星辰大海，令人心潮澎湃。',
      desc: '聚焦现场运营优化，<br/>以 <span style="font-weight: 600;">AI+IoT+机器人+自动化</span><br/>实现全要素连接、分析与优化。<br/>凭借行业领先的实践成果，持续引领创新前行。',
      feature1: '立足中国<br/>放眼全球',
      feature2: '专利、软著、商标等<br/>知识产权上百项',
      feature3: '服务年产值百亿以上<br/>客户500＋<br/>涉足行业40＋',
      feature4: '已服务70+<br/>汽车品牌<br/>行业经验丰富',
      businessTitle: '业务布局',
      company1: '北京总部',
      companyDesc1: '北京市经济开发区荣华南路2号大族广场T6-3层',
      company2: '上海公司',
      company3: '常州公司',
      company4: '苏州公司',
      company5: '广州公司',
      company6: '合肥公司',
      company7: '新加坡公司',
      center: '全国客服中心',
    },
    // 联系我们
    contact: {
      title: '联系我们，<br/>为您量身打造数智化物流<br/>与智能制造解决方案。',
      desc: '以人工智能赋能产业升级，用数字技术重构运营效率，<br/>助力各行业实现高效、安全、智能的现代化转型。',
      formTitle: '一站式实现数智化转型与智能运营',
      field1: '姓名',
      field2: '公司',
      field3: '您的邮箱',
      field4: '您的电话',
      field5: '您的咨询信息',
      submit: '提交',
      tips: '通过提交此表单，您同意我们的使用条款、隐私政策，并同意接收来自我们的营销通讯。',
    },
    // Wisdom AI人工智能
    wisdomAi: {
      banner: {
        title: 'Wisdom AI人工智能',
        desc: 'Wisdom AI 赋能数智化运营，帮助用户挖掘痛点、模拟运营、生成方案、<br/>改善实践，视觉分析，动态规划及实时优化资源调度',
        btnText: '联系我们',
      },
      productList: {
        aiLabel1: 'Operation Agent Brain',
        aiDesc1: '连接全域运营数据与现场上下文，实现问题诊断、方案仿真、智能决策与授权执行',
        aiLabel2: '视觉AI训推一体化平台',
        aiDesc2: '打通视觉数据采集、标注、训练、部署与持续学习，让AI从识别现场走向理解与行动',
        aiLabel3: '可控数字员工',
        aiDesc3: '让AI像员工一样操作企业软件，把运营知识转化为可执行动作',
        label1: 'AI 现场运营痛点挖掘',
        desc1: '让每个销售都可拥有专家级痛点挖掘能力，快速把握需求，让商机倍增',
        label2: 'AI 运营模拟分析',
        desc2: '可视化模拟+量化对比，快速确定改善方向，让方案效果直观可见，决策周期缩短 60%',
        label3: 'AI 解决方案自动生成',
        desc3: '企业知识AI自学习+模板及内容可控，3分钟完成专业个性化方案，让售前轻松应对全球客户需求',
        label4: 'AI 现场改善实践评估',
        desc4: '快速搭建真实业务场景，支持远程演示、在线培训与PoC验证，让方案能力直观可见、快速验证',
        label5: 'AI 动态规划与实时优化调度',
        desc5: 'AI 动态规划与实时优化调度，智能调配资源，高效响应运营全场景动态需求',
        label6: 'AI 视觉分析',
        desc6: 'AI 视觉分析，实时感知现场状态，智能识别异常提效降险',
      }
    },
    // Wisdom - BI分析与数字孪生
    wisdomAnalysis: {
      banner: {
        title: 'Wisdom - BI分析与数字孪生',
        desc: 'AloT全域感知科技，实现全场景场域要素数据采集，实时分析并调度场域<br/>资源，实现资源最优配置',
      },
      productList: {
        label1: '全场景数字孪生',
        desc1: '复刻线下全运营场景，实时映射状态，实现数智化可视可管可控',
        label2: '实时运营指标分析',
        desc2: '多维度抓取运营数据，实时分析拆解，精准洞察运营核心问题',
        label3: '现场管理驾驶舱',
        desc3: '聚合核心运营数据，可视化集中管控，一键掌握现场运营全貌',
      }
    },
    // 业务管理系统
    businessManage: {
      banner: {
        title: '业务管理系统',
        desc: '全链路覆盖产运储管核心环节，数智化赋能业务高效协同运营',
      },
      productList: {
        label1: 'LES 物流执行系统',
        desc1: '全流程管控物流执行环节，智能调度作业，提升物流运转效率',
        label2: 'WMS 仓库管理系统',
        desc2: '精细化管控仓储全流程，优化库位库存，提高仓储作业精准度',
        label3: 'SRM 供应商管理系统',
        desc3: '全维度管理供应商资源，协同供需链路，提升供应链协作效率',
        label4: 'SPS 台套化配送系统',
        desc4: '精准实现台套化物料配送，适配生产节拍，保障产线高效运转',
        label5: 'LCT 物流控制塔',
        desc5: '实时监控物流全链路状态，智能预警调度，实现物流全局管控',
        label6: '其他智能制造业务软件',
        desc6: '集成各类智能制造管理模块，打通生产、物流、管理数据，助力企业数字化转型与精益运营',
        // label6: 'EAM 资产管理系统',
        // desc6: '全生命周期管理企业资产，优化运维策略，提升资产利用价值',
        label7: 'EMS 能源管理 (高)',
        desc7: '精细化监控分析能源消耗，智能优化管控，实现高效节能降耗',
        label8: 'MES 制造执行系统',
        desc8: '全流程管控生产制造环节，打通产线数据，提升生产运营效率',
        label9: 'QAS 质量保证系统',
        desc9: '全链路把控产品质量环节，智能检测分析，筑牢品质管控防线',
      }
    },
    // Noah智能硬件/设备连接控制平台
    noah: {
      banner: {
        title: 'Noah智能硬件/设备连接控制平台',
        desc: '实时连接并监测IoT硬件状态，精准捕捉硬件运行数据，智能调节硬件运行参数；<br/>设备的连接及控制，实现高效联动管控，搭配实时数据传输，无缝衔接IT系统，<br/>全面提升综合运营效率',
      },
      platform: {
        title: '场域要素数智优化不可或缺的“中间”力量',
        subTitle: '实时连接并监测IoT硬件状态，精准捕捉硬件运行数据，智能调节硬件运行参数；设备的连接及控制，实现高效联动管控，搭配实时数据传输，无缝衔接IT系统，全面提升综合运营效率',
        controlTitle: 'Noah智能硬件/设备连接控制平台',
        list: {
          label1: '设备管理',
          desc1: '设备管理、可靠性监测、预测式运维及优化',
          label2: '数据管理',
          desc2: '数据接口管理、数据安全存储、快捷统计分析',
          label3: '平台管理',
          desc3: '平台自身可靠性监测、管理、预测及数据安全保障',
        },
      },
      featureTitle: 'Noah智能硬件/设备连接控制平台特点',
      featureList: {
        label1: '多协议适配',
        desc1: '支持多种网络接入协议<br/>轻松接入各种物联网设备',
        label2: '快速集成及调试',
        desc2: '设备自动识别，系统提供虚拟<br/>在线调试工具，便于调试',
        label3: '设备状态实时监测',
        desc3: '实时监测设备状态<br/>并对异常设备进行报警',
        label4: '装备集成调度',
        desc4: '多类型自动化装备、智能设备，<br/>IoT硬件的统一集成与调度',
        label5: '可视化运维',
        desc5: '系统提供平面可视化／网络可视化等<br/>多种可视化场景便于快速定位问题',
        label6: '完善的API',
        desc6: '提供提供开放、完善<br/>的API接口便于系统对接',
        label7: '大数据分析',
        desc7: '系统提供大数据分析接口，<br/>针对业务数据及运维数据进行分析',
        label8: '多类型，多品牌装备协同使用',
        desc8: '包括AGV，AMR，CTU，无人叉<br/>车，堆垛机，穿梭车，输送线，分<br/>拣机器人，机械臂等',
      }
    },
    // 物流自动化
    automation: {
      banner: {
        title: '物流自动化',
        desc: '全流程智能自动化运营，自动执行复杂任务，大幅提效并<br/>减少人工干预失误',
      },
      productList: {
        label1: 'AS/RS系统',
        desc1: 'AS/RS 自动化仓储系统适配多种货位形式，承载轻重货物，运行稳定，支持智能调度与开放扩展，统一运维高效可靠',
        label2: 'Miniload系统',
        desc2: 'Miniload 自动化系统适配多工位与货叉形式，运行稳定可靠，支持智能联动、统一运维与开放扩展',
        label3: '托盘多向穿梭车立库系统',
        desc3: '托盘多向穿梭车立库系统适配多向运行与温区环境，运行稳定，可智能调度、统一运维，系统开放易扩展',
        label4: '箱式多向穿梭车立体库',
        desc4: '箱式多向穿梭车立体库适配广、运行稳定，支持智能调度与统一运维，系统开放灵活，高效可靠',
        label5: '潜伏机器人',
        desc5: '潜伏机器人系列适配举升、底盘、叉取多场景，性能稳定可靠，支持智能调度与开放运维，高效灵活',
        label6: '料箱机器人',
        desc6: '料箱机器人覆盖单箱、多箱、分拣站场景，精准对接、高效转运，性能稳定，支持智能调度与开放运维',
        label7: '叉取机器人',
        desc7: '叉取机器人覆盖堆高、搬运、T 叉、前移多场景，性能稳定可靠，支持智能调度与开放运维，高效灵活',
        label8: '重载机器人',
        desc8: '重载机器人适配举升、光伏、汽车总装等场景，性能稳定可靠，支持智能调度与开放运维，高效承载',
        label9: '复合机器人',
        desc9: '复合机器人集成移动底盘、机械臂与视觉，高精度高柔性，性能稳定，支持智能调度与开放运维',
        label10: '室外搬运机器人',
        desc10: '室外搬运机器人适应复杂户外场景，通过性强、续航持久，运行稳定，支持智能调度与开放运维',
        label11: '拆码垛机',
        desc11: '拆码垛机可自动完成拆垛、码垛等作业，高效稳定，适配多类物料，支持智能调度与开放运维',
        label12: '输送线',
        desc12: '输送线可自动连续输送物料，布局灵活、运行稳定，可智能联动调度，系统开放易对接运维',
        label13: '提升机与梯控',
        desc13: '提升机实现物料垂直输送，梯控打通跨楼层物流，二者无缝对接，高效稳定，助力自动化流转',
        label14: '机械臂',
        desc14: '机械臂动作精准、柔性强、负载广，作业稳定，可智能联动调度，系统开放易运维',
      }
    },
    // AI机器人
    aiRobot: {
      banner: {
        title: 'AI机器人',
        desc: '智能 AI 机器人赋能现场运营，自主感知决策，精准执行任<br/>务，降本提效增质',
      },
      productList: {
        label1: 'AI智能机器人',
        desc1: '基于具身智能技术、Multi-Agent多智能体架构与工业行业Know-how，AI智能机器人融合听、说、看、分析、思考、自主移动等多维智能能力，支持跨系统操作与人员、设备、机器人资源协同调度，围绕运营现场的多种情况进行主动发现、智能分析、上报、协同处置与结果反馈，形成完整的业务运营闭环，推动制造现场从被动响应向主动智能运营升级',
        label2: 'AI巡检机器人',
        desc2: '基于 图像识别+多传感技术融合，机器人可全方位的进行现场巡查、异常发现、视觉分析、IoT感知等操作，保障运营现场的安全和规范',
      },
      featureList: {
        title: 'AI机器人产品特性',
        label1: 'AI 机器人软件大模型 —— 赋予机器人智能大脑',
        desc1: '搭载语音与图像大模型，支持自然语言交互、智能问答，可智能识别仪表与行为状态',
        label2: 'Multi-Agent —— 赋能机器人的专业问题处理能力',
        desc2: '结合图像识别、多传感融合、Multi-Agent技术及行业know-how，机器人能对业务异常进行分析和学习，并且具备专业问题分析、数据挖掘、跨系统操作、资源协调调度等高级的业务处理能力',
        label3: '全域自主巡航，智能无死角巡检',
        desc3: '支持自定义定时巡航与灵活点位配置，采用 3D 激光 SLAM + 深度相机精准导航，搭配双重避障，安全穿行复杂狭窄场景',
        label4: '多传感协同感知，全域风险智能预警',
        desc4: '搭载双光谱智能云台，实现测温、预警、入侵监测，配合全向环境传感器，全方位识别安全隐患',
        label5: '智能交互中枢，高效便捷人机协同',
        desc5: '云台可全方位旋转、远程操控，支持定制化语音播报，灵活满足巡检场景下的交互与播报需求',
        label6: '永续作业保障，全天候稳定值守',
        desc6: '配备自动回充系统，低电量自动精准充电，支持 7×24 小时不间断巡检，杜绝漏检、断档问题',
      },
      sceneList: {
        title: '应用场景',
        label1: 'AI安全管理员',
        desc1: '成为企业24小时安全·设备管理员；可执行企业安全员大部分工作，且发现问题更全面，处理更迅速，数据积累更完整，工作不敷衍',
        label2: 'AI设备工程师',
        desc2: '成为企业24小时设备工程师；可执行企业设备工程师大部分巡检工作，且发现问题更全面，处理更迅速，数据积累更完整，工作不敷衍',
        label3: 'AI班组长',
        desc3: '成为企业24小时全车间班组长，随时解决异常事件，解答一线员工作业问题与上级管理人员数据问题，调度资源，组织开会，日常管理',
        label4: 'AI数据分析员',
        desc4: '成为管理人员数据助理，深度结合业务系统数据与分析结果，实时查询、计算、分析所需数据并给出对比，预警等结论建议',
        label5: 'AI质量专员',
        desc5: '成为企业随叫随到的质量问题记录专员，项目零件跟踪专员，处理复杂流程管理事件并自动生成相关报告',
        label6: 'AI培训专员·参观宣讲员',
        desc6: '成为企业培训专员，执行具体培训工作，同时可引领可与参观',
        label7: 'AI IE工程师/规划工程师',
        desc7: 'AI 机器人模拟 IE 工程师，全方位观测现场运营，分析布局、路线与流量瓶颈，智能诊断异常问题',
        label8: 'AI 园区卡车调度员',
        desc8: 'AI 园区卡车调度员，智能调度园区车辆，优化路线与通行效率，保障物流高效、安全、有序运转',
        label9: 'AI LES系统补货巡查员',
        desc9: '补充LES难以覆盖的拉动任务；观察LES拉动需求与实际拉动补货结果之间的差异及问题，不断优化LES拉动精度提升效率减少浪费',
        label10: 'AI Wsidom运营助手',
        desc10: 'Wisdom分析及调度现场运营时，AI机器人可作为其物理助手，执行现场观察及现场调度协调等任务',
        label11: '仪器仪表巡检',
        desc11: '自主巡检仪器仪表，记录异常，替代人工高频巡检，保障设备稳定运行',
        label12: '红外测温',
        desc12: '实时采集温湿度、烟雾等环境数据，异常阈值自动告警，提前规避现场安全隐患',
        label13: '环境感知',
        desc13: '远距离非接触测温，快速筛查设备温度异常，精准定位发热点，避免停机风险',
      }
    },
    // 跟随机器人
    followRobot: {
      banner: {
        title: '跟随机器人',
        desc: 'UWB 高精度智能随行，融合避障更安全，四驱灵活通行，<br/>工业稳定可靠，解放双手提升作业效率',
      },
      productList: {
        label1: '跟随机器人',
        desc1: '跟随机器人智能随行，全程跟人无需手推，窄道灵活通行，工业级稳定不掉队，安全避障，让工人专注作业、高效又省心。',
      },
      featureList: {
        title: '跟随机器人产品特性',
        label1: 'UWB 高精度跟随',
        desc1: '双基线定位抗金属干扰，跟随距离可调，轨迹平滑不漂移，工业环境稳定不掉队',
        label2: '多源融合避障',
        desc2: '激光 + 超声波互补感知，全覆盖识别障碍物，检出率近 100%，通行更安全',
        label3: '四驱高机动底盘',
        desc3: '四轮差速可原地转向，适应复杂地面，载重有多种规格可选，窄道自如通行',
        label4: '跟随遥控双模式',
        desc4: '自动跟人跟车，支持编队作业，可选遥控操控，适配多场景灵活调度',
        label5: '工业级高效可靠',
        desc5: '解放双手专注作业，误停率低，部署灵活，适配制造、轨交、机场等场景',
      },
      sceneList: {
        label1: '制造业装配线',
        desc1: '适配汽车、家电、电子产线，自动随行送料，提升装配效率',
        label2: '轨道交通维修',
        desc2: '复杂维修场地稳定跟随，搬运工具物料，解放维修人员双手',
        label3: '机场地勤保障',
        desc3: '机坪高强度作业，抗干扰强，安全避障，高效转运物资',
        label4: '工业车间搬运',
        desc4: '金属密集环境不掉队，窄道灵活通行，替代手推车省力安全',
        label5: '设备检修现场',
        desc5: '室内外全地形通行，重载可靠，随人运送检修器材',
      }
    },
    // 穿戴式设备
    wearableDevices: {
      banner: {
        title: '穿戴式设备',
        desc: '无纸化作业，实时感知与回传，精准高效，赋能仓储智能化流转',
      },
      productList: {
        label1: '智能穿戴扫码终端',
        desc1: '全流程管控物流执行环节，智能调度作业，提升物流运转效率',
        label2: '腕带显示型定位手表',
        desc2: '腕式便携设计，实时定位可视，快速掌握人员动态，助力现场高效管控',
        label3: '智能穿戴式PDA',
        desc3: '内置扫描引擎模块可实现对条码、二维信息的快速识别，穿戴式佩戴方式，解放现场作业人员双手',
        label4: '无源RFID手环',
        desc4: '无源 RFID 手环，配合 PTL 实现远距离识别，高效精准识别',
        label5: '(NFC/UWB/蓝牙)胸卡',
        desc5: '胸卡便携设计，实时定位可视，快速掌握人员动态，助力现场高效管控',
        label6: 'UWB安全帽',
        desc6: 'UWB 智能安全帽，精准定位防撞，守护现场作业安全',
        label7: 'RFID感应工服',
        desc7: 'RFID 感应工服，快速身份识别，便捷考勤与区域权限管理',
      }
    },
    // 物流车辆状态自采集设备
    selfCollectDevices: {
      banner: {
        title: '物流车辆状态自采集设备',
        desc: 'AloT智能设备赋能，实时监测物流车辆、驾驶员的作业状态，全局概览无<br/>死角，全方位优化车辆运营',
      },
      productList: {
        label1: '传感采集控制器',
        desc1: '专用传感采集控制器，多维度采集作业数据，实时传输稳定适配工业工况',
        label2: '各类车载传感器',
        desc2: `<span>· 障碍物防撞传感器</span><span>· 安全带采集器</span><br/><span>· 人车防撞传感器</span><span>· 车速采集传感器</span><br/><span>· RFID货物识别传感器</span>`,
        label3: '车辆货物识别器',
        desc3: '车辆货物识别器，自动识读货物标识，免扫描精准核验，实现物资动态追踪',
        label4: '车辆安全带采集器',
        desc4: '安全带采集器，实时检测佩戴状态，未系自动报警，规范操作保障人员安全',
        label5: '车速采集器',
        desc5: '车速采集器，精准实时采集行驶速度，支持限速联动，杜绝超速作业隐患',
        label6: '车载电脑',
        desc6: '工业级车载电脑，抗振防水，联动系统实时交互，智能调度高效作业',
      }
    },
    // 高精度定位设备
    positioningDevices: {
      banner: {
        title: '高精度定位设备',
        desc: '自主研发多维融合定位算法，可实现精确定位人员、车辆、资产，并在定<br/>位基础上实现轨迹追踪、区域报警、摄像联动等',
      },
      productList: {
        label1: 'UWB 实时定位系列',
        desc1: 'UWB 实时定位系列，单边精准定位，10-20cm 高精度，抗干扰适配复杂工业场景',
        label2: '蓝牙AOA定位系列',
        desc2: '蓝牙 AOA 定位系列，低成本广域覆盖，亚米级定位，高效实现人员资产区域管控',
        label3: 'UWB+RTK多模定位',
        desc3: 'UWB+RTK 多模定位，室内外无缝衔接，全场景高精度，适配多元定位管理需求',
        label4: 'GPS/北斗/RTK定位',
        desc4: '支持 GPS、北斗多模卫星定位，可选配 RTK 模块，定位精准稳定，满足各类场景实时位置监测与调度需求',
      }
    },
    // 无纸化显示、一键更新设备
    updateDevices: {
      banner: {
        title: '无纸化显示、一键更新设备',
        desc: '实时显示库存，方便工作人员补货，显示丰富的信息<br/>如二维码、条形码等，增强与人的交互。',
      },
      productList: {
        label1: '电子墨水屏',
        desc1: '一键更新所有场景下的信息显示内容，刷新速率快，快速更换多场景信息显示',
        label2: 'UWB电子纸定位终端',
        desc2: '集高精度定位与信息展示于一体，适用于工厂仓储人员、车辆、物料定位调度',
      }
    },
    // 快速盘点、批量扫描设备
    scanDevices: {
      banner: {
        title: '快速盘点、批量扫描设备',
        desc: '非接触式识别，识别距离远，完成识别无需人工干预，自动化，<br/>替代传统人工，对人、车、器具、货品等快速批量扫描',
      },
      productList: {
        label1: '超高频RFID系列',
        desc1: '无需人工干预，远距离非接触式识别，更加方便作业现场的数据追踪，使得工厂运营更为便捷',
        label2: '扫码及PDA',
        desc2: '高效识别标签，批量采集数据，提升仓储盘点精准效率',
        label3: 'RFID/视觉扫描门',
        desc3: '无感快速识别，批量数据采集，提升仓储出入库效率',
        label4: '智能盘点柜',
        desc4: '智能盘点柜，智能识别盘点，权限管控，高效安全管理物资',
        label5: '智能盘点车',
        desc5: '快速精准盘点仓储物料，大幅提升盘点效率与数据准确性',
      }
    },
    // 安全防护类设备
    safetyDevices: {
      banner: {
        title: '安全防护类设备',
        desc: '全方位安全监测防护，实时预警异常，守护作业环境稳定可靠',
      },
      productList: {
        label1: 'UWB防碰撞系列',
        desc1: 'UWB 防碰撞系列，高精度实时测距，智能预警避障，保障设备与人员作业安全',
        label2: '危险区域防护系列',
        desc2: '智能监测危险区域，实时预警禁入，守护作业安全',
        label3: '防丢系列',
        desc3: '精准定位，实时防丢，有效保障工具、枪械及贵重便携物品安全',
      }
    },
    // 智能亮灯指引设备
    guidanceDevices: {
      banner: {
        title: '智能亮灯指引设备',
        desc: 'AloT智能设备赋能传统设施，摆脱经验依赖，拣选<br/>效率及准确率提升，提升现场管理水平',
      },
      productList: {
        label1: 'PTL +X灯光指引拣选系列',
        desc1: '在传统灯光拣选系统中增加动态感知模块，通过智能手环、智能推车等设备赋能现场的人和设施，实现单人/多人多单拣选/混选，动态库位以及自动触发补货拉动等功能',
        label2: 'SMT 亮灯指引料架',
        desc2: '通过灯光+数字指引，员工无需培训即可上岗作业，降低对于人员依赖，降本增效',
      }
    },
    // 无人值守设备
    unattendedDevices: {
      banner: {
        title: '无人值守设备',
        desc: '定物资身份与人员权限，实时监测柜内物资，智能核对登记，<br/>提效降本保安全',
      },
      productList: {
        label1: 'RFID智能柜',
        desc1: '智能盘点柜，智能识别盘点，权限管控，高效安全管理物资',
        label2: '无人值守仓库设备',
        desc2: '对出入库物料、器具、车辆进行自动识别、扫描、记账、清点，大幅提高物流效率',
      }
    },
    // 工器具流转跟踪设备
    trackDevices: {
      banner: {
        title: '工器具流转跟踪设备',
        desc: '工器具流转跟踪设备，UWB 实时定位 + RFID 识别，全程追踪<br/>工器具流转，精准管控提效',
      },
      productList: {
        label1: 'UWB 实时定位标签',
        desc1: 'UWB 实时定位系列，单边精准定位，10-20cm 高精度，抗干扰适配复杂工业场景',
        label2: '超高频RFID标签',
        desc2: '无需人工干预，远距离非接触式识别，更加方便作业现场的数据追踪，使得工厂运营更为便捷',
        label3: 'GPS/北斗/RTK标签',
        desc3: '支持 GPS、北斗多模卫星定位，可选配 RTK 模块，定位精准稳定，满足各类场景实时位置监测与调度需求',
      }
    },
    // 快速呼叫设备
    callDevices: {
      banner: {
        title: '快速呼叫设备',
        desc: '通过低功耗高可靠性的MESH网络，保证物料配送稳定，不停线',
      },
      productList: {
        label1: 'CBS无线按钮',
        desc1: '快速呼叫设备，无线物料呼叫拉动，稳配送保产线高效不停工',
        label2: '空箱触发无线拉动',
        desc2: '空箱触发无线呼叫，智能拉动物料补给，稳定配送保障产线高效连续运转',
      }
    },
    // 信息·身份·数量识别感知设备
    perceptionDevices: {
      banner: {
        title: '信息·身份·数量识别感知设备',
        desc: '多维度智能感知识别，精准采集信息数据，筑牢运营感知<br/>与安全管控防线',
      },
      productList: {
        label1: '无人结算通道',
        desc1: '对出入库物料、器具、车辆进行自动识别、扫描、记账、清点，大幅提高物流效率',
        label2: '视觉扫描门',
        desc2: '视觉扫描门，快速无感扫描，高效实现身份与信息智能核验',
        label3: 'RFID扫描门',
        desc3: '无感快速识别，批量数据采集，提升仓储出入库效率',
        label4: '超高频RFID系列',
        desc4: '无需人工干预，远距离非接触式识别，更加方便作业现场的数据追踪，使得工厂运营更为便捷',
        label5: 'RFID扫码枪',
        desc5: '高效识别 RFID 标签，批量采集数据，提升仓储盘点精准效率',
        label6: '穿戴式扫码设备',
        desc6: '轻量化佩戴，智能感应扫码，打破空间限制，提升现场效能',
        label7: '条码识别',
        desc7: '高效条码识别，快速采集物料信息，提升仓储出入库流转效率',
        label8: '图像/OCR识别',
        desc8: '基于深度学习与图像识别，可智能检测定位表单，高速精准识别并解析输出内容',
      }
    },
    // 作业指引及防错提示类设备
    promptDevices: {
      banner: {
        title: '作业指引及防错提示类设备',
        desc: '通过智能手环、智能推车等设备赋能现场的人和设施，实现单人/多人多单<br/>拣选/混选，动态库位以及自动触发补货拉动等功能',
      },
      productList: {
        label1: '透明感知库位',
        desc1: '智能感知货位，实时可视化库存，支持精准上下架与自动盘点，低成本实现仓储高效透明管理',
        label2: '智能拣选小车',
        desc2: '内置 PTL 终端，灯光指引清晰，一体化操作更顺手，大幅降低作业强度，提升拣选准确率',
        desc3: `<span>· 拨杆拣选</span><span>· RFID感应拣选</span><br/><span>· 按钮拣选</span><span>· 双向拣选</span><br/><span>· 光感拣选</span><span>· 拉绳拣选</span>`,
      }
    },
    // 行李识别设备
    baggageIdentification: {
      banner: {
        title: '行李/大件物品识别及扫描设备',
        desc: '批量自动扫描行李标签，并进行图像采集，实现随时核对、实时监控的功能',
      },
      platform: {
        title: '行李/异形件识别及扫描设备系列',
        controlTitle: '技术特点',
        list: {
          label1: '自动扫描',
          desc1: '可对各种货物包括不规则货物进行批量的自动扫描',
          label2: '位置甄别',
          desc2: '通过识别功能，全程跟踪行李流转',
          label3: '图像采集',
          desc3: '拍摄货物流转过程中的外观，进行识别定位',
        },
      },
      featureTitle: '应用价值',
      featureList: {
        label1: '实时监测行李和物品状态',
        desc1: '批量自动扫描行李标签，并进行图像采集，<br/>实现随时核对、实时监控的功能',
        label2: '减少人为失误',
        desc2: '自动扫描，避免漏扫失误，<br/>避免因人工扫描造成的行李丢失和错送',
        label3: '提升服务品质',
        desc3: '快速、精准地识别，实时监测和事后追溯，<br/>防止行李遗失，提升旅客满意度，提高品牌价值',
      },
      sceneTitle: '应用场景',
      scene1: '机场行李开包分拣',
      scene2: '机场行李离港、中转、到港扫描',
      scene3: '大件快递流转过程识别',
    },
    // 行业集合
    applicationIndustry: {
      title: '应用行业',
      industry1: '汽车行业',
      industry2: '汽配行业',
      industry3: '工程机械',
      industry4: '白色家电',
      industry5: '装备制造',
      industry6: '生物医疗',
      industry7: '食品烟草日化',
      industry8: '冶炼冶金',
      industry9: '电子电器',
      industry10: '图书电商及其他物流',
      industry11: '化工行业',
      industry12: '高铁制造',
      industry13: '航空航天',
      industry14: '交通运输',
      industry15: '市政公共服务',
      industry16: '医疗服务',
    },

    // 供应链管理场景
    supplyChain: {
      banner: {
        title: '供应链管理（含集装箱堆场）',
        desc: '供应链全程跟踪，风险实时分析预警，精准控库存降成本/多人多单<br/>拣选/混选，动态库位以及自动触发补货拉动等功能',
      },
      productList: {
        label1: '海运跟踪',
        desc1: '实时追踪船运订单及周转器具/箱柜的位置，关联多维度信息，预测到港及延误风险并提前预警',
        label2: '陆运跟踪',
        desc2: '实时跟踪陆运车辆，关联订单号，零件信息，预测延误风险，提前预警保障足够应对时间',
        label3: '智能掏箱运算',
        desc3: '运筹算法智能选集装箱，减呆滞罚款避非必要库存，算最优解',
        label4: '风险提醒',
        desc4: '订单变更时，自动对比物料计划，智能研判生产影响，超阈值自动预警',
      }
    },
    // 原料外仓管理场景
    material: {
      banner: {
        title: '原料外仓管理',
        desc: '数字化原料外仓管理，实时追踪库存与物流，降本增效赋能业<br/>务拓展',
        desc2: '原料外仓管理包含如下园区管理、月台管理、装卸车及入库、存储与理货、拣选备货、配送搬运等子场景',
      },
      productList: {
        label1: '园区管理',
        desc1: '均衡运输流量，减少作业波峰波谷，有序入厂，减少供应商车辆等待，按计划入场实现精益管理，全程车辆跟踪预警风险',
        label2: '月台管理',
        desc2: '提高月台利用率，智能化调度减少人工干预',
        label3: '装卸车及入库',
        desc3: '通过共享装卸车的叉车资源。取消定人定岗，优化作业调度，依托条码智能识别，实现货物自动入库与全流程自动化，降本增效',
        label4: '存储与理货',
        desc4: '通过智能IoT设备，实现库存精准管控、高效理货盘点，优化作业流程，降本增效，保障仓储秩序与运营效率',
        label5: '拣选备货',
        desc5: '拣选备货场景依托智能指引与 IoT 硬件，精准高效完成拣货备货，降本防错，提升仓储作业整体生产力',
        label6: '配送搬运',
        desc6: '配送搬运场景通过智能调度与设备协同，优化搬运路径、减少等待耗时，实现车辆、人员、设备高效联动，提升物流配送整体效率与运营效益',
      }
    },
    // 园区管理
    park: {
      banner: {
        title: '园区管理',
        desc: '均衡运输流量，减少作业波峰波谷，有序入厂，减少供应商车<br/>辆等待，按计划入场实现精益管理，全程车辆跟踪预警风险',
      },
      productList: {
        label1: '车辆预约入园',
        desc1: '可自定义预约规则，司机在一定距离内可动态改约；对接道闸自动放行，依预约统筹园区资源',
        label2: '车辆均衡入园',
        desc2: '按窗口约束司机预约，实时记录装卸时长，优化窗口分配，均衡货车的园内停留时间，疏解集中作业，降低人力与叉车成本',
        label3: '车辆排队管理',
        desc3: '根据月台卡车实时状态与预测叫号，减少等待',
        label4: '车辆位置实时跟踪管理',
        desc4: '实时监控园区车辆位置，划定行车区域，防范非法闯入；统计停车与作业时长，优化流程、减少等待，提升供应链效率',
      }
    },
    // 月台管理
    platform: {
      banner: {
        title: '月台管理',
        desc: '提高月台利用率，智能化调度减少人工干预',
      },
      productList: {
        label1: 'UWB — <br/> 月台车辆实时高精度定位管理',
        desc1: '实时定位园区车辆，监控泊位与月台状态，避免装卸入位错误',
        label2: 'UWB — <br/> 月台装卸货实时调度',
        desc2: '系统自动调度车辆，依据月台空满调度车辆，监控装卸时长，超时自动报警，减少管理人员投入',
      }
    },
    // 装卸车及入库管理
    inStorage: {
      banner: {
        title: '装卸车及入库管理',
        desc: '通过共享装卸车的叉车资源、取消定人定岗，优化作业调度，依托条<br/>码智能识别，实现货物自动入库与全流程自动化，降本增效',
      },
      productList: {
        label1: 'WISDOM调度 — 叉车/拖车状态调度',
        desc1: 'Wisdom调度平台实时监控装卸货的叉车/拖车状态，智能调度分配，提升运输效率，保障物流顺畅运行',
        label2: '视觉扫描 — 收货 — <br/> 视觉识别扫描物流门',
        desc2: '采用视觉智能扫描识别货物，高准确率自动核验，无需人工，高效完成收货入库',
        label3: 'RFID — 收货 — <br/> RFID识别物流门',
        desc3: '通过物流门 RFID 自动识别货物信息，无感核验，提升收货效率，减少人工干预',
        label4: 'RFID — 收货 — <br/> RFID识别穿戴设备',
        desc4: '搭载 RFID 穿戴设备，移动智能识别货物，作业灵活高效，简化人工收货流程',
        label5: 'RFID — 收货 — <br/> RFID识别叉车改造',
        desc5: '叉车加装 RFID 识别设备，作业同步自动识货，精准高效，助力智能收货',
        label6: '入库叉车调度',
        desc6: '共享装卸车/叉车资源，智能调度叉车任务，减少等待与人力，优化入库作业流程',
        label7: 'AGV自动搬运入库',
        desc7: '货物自动识别、收货、入库全流程智能化，减人增效，实现无人化闭环作业',
      }
    },
    // 存储与理货
    tally: {
      banner: {
        title: '存储与理货',
        desc: '通过智能IoT设备，实现库存精准管控、高效理货盘点，优化<br/>作业流程，降本增效，保障仓储秩序与运营效率',
      },
      productList: {
        label1: 'UWB — <br/> 室内地堆库位/爆仓区管理与快速找货',
        desc1: 'UWB 精准定位，实现室内地堆与爆仓区库位可视化，快速找货提升效率',
        label2: 'UWB — 室内地堆库位先进先出精确管理',
        desc2: 'UWB 实时定位追踪，规范室内地堆流转，实现先进先出精准管控',
        label3: 'UWB — 室内行车作业区库位管理与快速找货',
        desc3: 'UWB 高精度定位，赋能行车作业区库位管理，快速定位货物安全高效',
        label4: 'UWB/RTK — <br/> 室外地堆库位/爆仓区管理与快速找货',
        desc4: 'UWB+RTK 融合定位，室外地堆与爆仓区可视化管理，快速找货零误差',
        label5: 'UWB/RTK — 室外地堆库位先进先出精确管理',
        desc5: 'UWB/RTK 双模定位，实现室外地堆全流程追溯，严格执行先进先出',
        label6: 'UWB/RTK — 室外行车作业区库位管理与快速找货',
        desc6: 'UWB+RTK 高精度定位，室外行车区库位智能管理，快速寻货更安全',
        label7: 'RFID叉车改造与货架RFID标签高精度快速库位管理',
        desc7: '叉车加装 RFID 识别设备，作业同步自动识货，精准高效，助力智能收货',
        // label8: 'UWB/RTK - 室外行车作业区库位管理与快速找货',
        // desc8: '搭载 RFID 穿戴设备，移动智能识别货物，作业灵活高效，简化人工收货流程',
        // label9: 'RFID - RFID叉车改造与货架RFID标签高精度快速库位管理',
        // desc9: '叉车加装 RFID 识别设备，作业同步自动识货，精准高效，助力智能收货',
        label10: 'WES — 堆垛机立库',
        desc10: '堆垛机立库与前后流程紧密配合，更高效发挥其存储能力及出入库作业能力。无人作业，高效准确',
        label11: 'WES — 多向穿梭车立库',
        desc11: '多穿立库与前后流程紧密配合，更高效发挥其存储能力及出入库作业能力。无人作业，高效准确',
        label12: 'PTL — 亮灯货位管理',
        desc12: '多种感应及指引方式的灯光指引货架作业，提高作业效率与准确率',
        label13: '动态库位管理',
        desc13: 'RF实时扫描货位容器信息，结合灯光指引可用于动态库位管理，提高作业效率与准确率',
        label14: 'WES — miniload立库',
        desc14: 'miniload与前后流程紧密配合，更高效发挥其存储能力及出入库作业能力。无人作业，高效准确',
        label15: 'WES — CTU货架',
        desc15: '针对传统货架，无需大规模基建改造，实现自动化存储智能，库位优化策略，可配置方案满足客户定制需求',
        // label16: 'WMS - WMS仓储管理系统',
        // desc16: '智能管控仓储全流程，精准盘点、高效调度，降本增效，赋能数字化仓储管理',
      }
    },
    // 拣选备货场景
    picking: {
      banner: {
        title: '拣选备货',
        desc: '拣选备货场景依托智能指引与 IoT 硬件，精准高效完成拣货备<br/>货，降本防错，提升仓储作业整体生产力',
      },
      productList: {
        label1: 'WMS仓库管理系统 — 拣选策略',
        desc1: '智能管控仓储全流程，精准盘点、高效调度，降本增效，赋能数字化仓储管理',
        label2: 'LES+PTL — 亮灯拣选',
        desc2: '台套化拣选精确备货，灯光指引精准拣选，保障物流精准配送，降低对工人技能要求。',
        label3: 'LES —【RF-PTL】— <br/> 单台套亮灯手环拣选',
        desc3: 'RF 手环拣选贴合人机工程，减动作浪费、防违规，精准记数据，提效降错还降低技能要求',
        label4: 'WMS+PTL — 多台套亮灯拣选',
        desc4: '支持多台套同时拣选，台套化拣选精确备货，灯光指引精准拣选，保障物流精准配送，降低对工人技能要求',
        label5: 'WMS+PTL  — 货位PTL与智能拣选小车双向亮灯拣选',
        desc5: '货架侧与拣选小车双向灯光指引，从某个库位取出放入某个库位有清晰指引，大幅提高拣选准确率与效率，降低对工人技能要求',
        label6: 'WMS+AGV+PTL 货到人拣选',
        desc6: 'AGV将所需拣选货物的货架/托盘搬运至拣选台，工人根据指引拣选，减少人工移动，提高拣选效率，减少人力投入',
        label7: 'WMS+输送线+PTL 货到人拣选',
        desc7: '输送线将所需拣选货物的料箱/托盘搬运至拣选台，工人根据指引拣选，减少人工移动，提高拣选效率，减少人力投入',
        label8: '电子分拣墙RF防错分拨',
        desc8: '电子分拣墙 RF 防错分拨方案，智能防错分拨，提升分拣精准度与效率，降低人工成本',
        label9: '全自动分拨墙分拨',
        desc9: '全自动分拨墙分拨方案，全程自动化作业，高效精准分拨，大幅提升仓储分拣效率',
        label10: '灯光指引地面分拨',
        desc10: '灯光指引地面分拨方案，灯光智能指引防错，高效完成分拨作业，提升分拣精准与效率',
        label11: '墨水屏指引排序作业',
        desc11: '墨水屏指引排序作业方案，墨水屏智能指引，精准高效排序，提升作业效率与准确性',
        label12: '灯光指引排序作业',
        desc12: '灯光指引排序作业方案，灯光智能指引防错，高效精准排序，提升作业效率与准确性',
        label13: 'RFID翻包信息跟踪',
        desc13: 'RFID 翻包信息跟踪方案，RFID 精准识别，全程跟踪翻包信息，提升作业溯源性与效率',
        label14: '拆码垛机自动翻包',
        desc14: '拆码垛机自动翻包解决方案，自动化翻包作业，高效精准，大幅减少人工投入提效降本',
      }
    },
    // 生产过程数据管理场景
    productionData: {
      banner: {
        title: '生产过程管理',
        desc: '生产过程管理场景依托 AIoT 技术实现生产全流程数据可视化，精准管控<br/>生产节点，提效降本，有效减少产线停线问题',
      },
      productList: {
        label1: '基于IoT的在制品跟踪',
        desc1: '依托 IoT 技术（RFID/UWB）实现在制品全流程追踪，数据可视化，保障生产物料供给及时、提效降本',
        label2: '生产下线跟踪管理',
        desc2: '依托IoT技术（RFID/UWB）对生产下线环节全流程数据化管控，实时跟踪状态，提升生产交付效率与溯源性',
        label3: '线边库库存管理',
        desc3: '智能化管控线边库库存，实时掌握库存动态，保障产线物料供给，减少产线停线',
        label4: '机器人巡线',
        desc4: '机器人自主完成产线巡线作业，实时监测产线状态，精准发现问题，提升巡线效率',
        label5: 'RFID生产投料防错管理',
        desc5: 'RFID 技术赋能生产投料，精准识别物料防错漏，提升投料准确率，保障生产有序进行',
        label6: 'UWB加工工艺防错管理',
        desc6: 'UWB 电子围栏管控工艺区域，实时校验作业流程，有效规避工艺失误，提升加工精度',
        label7: '现场装配跟随机器人',
        desc7: '现场装配跟随机器人，智能随行载料，安全避障，解放双手提升装配效率与作业安全',
        label8: 'WISDOM 生产数据分析及优化',
        desc8: '深度分析生产全维度数据，挖掘数据价值，优化生产资源配置，助力精益生产降本提效',
        label9: '现场设备数据采集可视化',
        desc9: '智能化采集生产全流程数据，实现数据统一管理、安全存储，为生产分析提供精准支撑',
        label10: 'WISDOM 效率分析',
        desc10: '智能采集分析设备运行数据，精准计算 OEE，挖掘瓶颈问题，助力提升设备综合效率',
      }
    },
    // 成品外仓管理场景
    externaWarehouse: {
      banner: {
        title: '成品外仓管理',
        desc: '成品外仓管理场景实现出库、装卸、运输全流程智能管控，优化资源调<br/>度，提升作业效率，保障成品仓储与配送高效有序',
        desc2: '成品外仓管理包含如下装卸车及入库、存储与理货、配送搬运、拣选备货等子场景',
      },
      productList: {
        label1: '装卸车及入库',
        desc1: '通过共享装卸车、取消定人定岗，优化作业调度，依托条码智能识别，实现货物自动入库与全流程自动化，降本增效',
        label2: '存储与理货',
        desc2: '通过智能IoT设备，实现库存精准管控、高效理货盘点，优化作业流程，降本增效，保障仓储秩序与运营效率',
        label3: '拣选备货',
        desc3: '拣选备货场景依托智能指引与 IoT 硬件，精准高效完成拣货备货，降本防错，提升仓储作业整体生产力',
        label4: '配送搬运',
        desc4: '配送搬运场景通过智能调度与设备协同，优化搬运路径、减少等待耗时，实现车辆、人员、设备高效联动，提升物流配送整体效率与运营效益',
      }
    },
    // 配送搬运场景
    delivery: {
      banner: {
        title: '配送搬运',
        desc: '通过自动化搬运、智能调度与设备协同，实现无人搬运及少人搬运，并优<br/>化搬运路径、减少等待耗时，实现车辆、人员、设备高效联动，提升物流<br/>配送整体效率与运营效益',
      },
      productList: {
        label1: '“滴滴式”就近调度',
        desc1: '实时动态就近调度可作业车辆，“滴滴”式调度大幅提升车辆OEE，提高效率30%以上',
        label2: '无人叉车配送',
        desc2: '针对托盘货物，实现无人化搬运，同时优化搬运设备的OEE及优化路线，实现无人搬运车辆数量的最小化',
        label3: 'AGV/AMR配送',
        desc3: '针对不同类型的货物和料箱，实现无人化搬运，同时优化搬运设备的OEE及优化路线，实现无人搬运车辆数量的最小化',
        label4: '室外无人牵引车运输',
        desc4: '采用室外无人牵引车自主作业，智能规划路径，安全高效运输，减少人力，提升厂区物流转运效率',
        label5: '室外无人卡车运输',
        desc5: '室外无人卡车自动驾驶运输，全程无人化作业，提升配送效率，降低人工成本，保障运输安全稳定',
      }
    },
    // 安全防护与运营规范管理场景
    operationalStandard: {
      banner: {
        title: '安全防护与运营规范管理',
        desc: '依托 IoT 感知与 AI 机器人技术，全面赋能厂区安全管控与运营规范，实<br/>现智能监测、风险预警、流程标准化，提升管理效率与安全保障',
      },
      productList: {
        label1: 'AI视觉火灾报警管理',
        desc1: '通过 AI 视觉智能识别火情，实时预警报警，快速响应，提升厂区消防安全防护能力',
        label2: 'AI机器人火灾报警管理',
        desc2: 'AI 机器人自主巡检识别火灾隐患，实时上报告警，保障厂区消防安全与应急处置',
        label3: 'AI视觉识别消防通道被占用',
        desc3: 'AI 视觉实时监测消防通道，自动识别占用违规行为，及时告警，保障通道畅通',
        label4: 'AI视觉防人/货碰撞管理',
        desc4: 'AI 视觉智能监测人与货物距离，实时预警碰撞风险，保障作业安全，减少事故',

        label5: 'AI视觉防人/车碰撞管理',
        desc5: 'AI 视觉识别人员与车辆动态，智能预判碰撞风险，及时预警，保障现场作业安全',
        label6: 'AI视觉防止进入危险区管理',
        desc6: 'AI 视觉实时监测危险区域，自动识别违规闯入，即时告警，规范人员安全行为',
        label7: 'UWB电子围栏防止进入危险区管理',
        desc7: 'UWB 精准定位搭建电子围栏，违规进入即刻预警，高效管控危险区域人员出入',
        label8: 'RFID自动识别防止进入危险区管理',
        desc8: 'RFID 自动识别物品与人员，管控危险区域准入，防止违规进入，保障作业安全',

        label9: 'AI机器人识别卡车阻轮器摆放',
        desc9: 'AI 机器人巡检识别阻轮器摆放状态，智能检测不规范问题，保障车辆停靠安全',
        label10: 'AI机器人识别卡车占用消防通道',
        desc10: 'AI 机器人自主巡查，智能识别车辆占用消防通道行为，实时告警，保障通道畅通',
        label11: 'AI机器人5S巡查',
        desc11: 'AI 机器人自动执行 5S 现场巡查，记录问题、规范现场管理，提升厂区环境与秩序',
        label12: '人员/贵重物资防丢',
        desc12: '精准定位守护人员与贵重物资，实时追踪、异常告警，高效防丢更安心',
        label13: '天车吊物防撞防砸',
        desc13: '实时监测天车吊物运行，智能防撞防砸，保障作业安全高效',
      }
    },
    // 设备巡检运维管理场景
    inspectionMaintenance: {
      banner: {
        title: '设备巡检运维管理',
        desc: '设备巡检运维管理场景依托智能感知与 AI 技术，实现设备状态实时监<br/>测、异常预警、高效运维，保障设备稳定运行，降低故障风险',
      },
      productList: {
        label1: '设备巡检RFID打卡管理',
        desc1: '采用 RFID 技术实现设备巡检自动打卡，规范巡检流程，记录真实数据，保障设备运维可追溯',
        label2: '设备巡检UWB打卡管理',
        desc2: '依托 UWB 高精度定位，实现巡检智能打卡与轨迹监管，提升巡检效率，杜绝漏检代检',
        label3: '设备巡检RTK打卡管理',
        desc3: '基于 RTK 高精度定位技术，实现巡检精准打卡，强化运维监管，保障设备巡检高效可靠',
        label4: 'AI机器人设备巡检',
        desc4: 'AI 机器人自动巡检设备，实时监测数据、异常预警，替代人工更安全高效',
        label5: '设备维修跟随机器人',
        desc5: '设备维修跟随机器人，智能随行载物、安全避障，解放双手提升检修效率',
      }
    },
    // 资产管理场景
    property: {
      banner: {
        title: '资产管理',
        desc: '资产管理场景通过物联网与智能识别技术，实现资产全生命周期可视化管<br/>理，精准盘点、高效追溯，提升资产利用率与管控水平',
      },
      productList: {
        label1: 'RFID快速盘点',
        desc1: '依托 RFID 技术实现物资快速盘点，大幅提升盘点效率，减少人工误差，实现资产高效管控',
        label2: 'RFID备件物资管理',
        desc2: 'RFID 备件物资管理，快速识别盘点，精准出入库，高效追溯提升管理效率',
        label3: '医疗耗材RFID管理及<br/>无人结算通道',
        desc3: '以 RFID 实现医疗耗材全流程管控，搭配无人结算，提升耗材管理效率与使用安全性',
        label4: '无人货柜/无人值守仓库',
        desc4: '打造无人化智能仓储与货柜管理，实现自助存取、自动核算，降本增效，简化管理流程',
        label5: 'RFID 容器跟踪管理',
        desc5: '基于 RFID 技术实现容器全流程自动识别与追踪，实时监控位置与状态，提升流转效率，实现智能化闭环管理',

        label6: 'UWB 容器跟踪管理',
        desc6: '采用 UWB 高精度定位，全程跟踪容器位置与状态，实现物流容器可视化、智能化管控',
        label7: 'GPS 容器跟踪管理',
        desc7: '通过 GPS 实时定位容器位置，支持远程监控与轨迹追溯，保障运输全程可视可控，有效防止丢失与延误',
        label8: 'RFID/UWB资产设备管理及跟踪',
        desc8: 'RFID+UWB，实现资产设备全生命周期精准管理与实时跟踪',
      }
    },
    // 人员管理场景
    staff: {
      banner: {
        title: '人员管理',
        desc: '人员管理场景依托智能定位与感知技术，实现人员位置、轨迹、考勤规范<br/>化管控，保障作业安全，提升人员管理效率与合规水平',
      },
      productList: {
        label1: 'Wisdom 人员实时动态调度',
        desc1: '依托智能系统实现人员实时调度与合理分配，优化人力配置，提升现场作业响应与管理效率',
        label2: 'UWB人员实时定位跟踪管理',
        desc2: '采用 UWB 高精度定位，实时监控人员位置与轨迹，实现人员可视化管理，保障作业安全',
        label3: 'UWB人员 危险区/保密区 进出管理',
        desc3: '通过 UWB 电子围栏管控区域进出，自动预警违规行为，强化安全管控，规范人员通行',
        label4: 'Wisdom 人员效率及利用率分析',
        desc4: '智能采集分析人员作业数据，精准计算人员OEE，挖掘瓶颈问题，助力提升人员综合效率',
        label5: 'WISDOM 效率分析方案',
        desc5: '智能采集分析设备运行数据，精准计算 OEE，挖掘瓶颈问题，助力提升设备综合效率',
        label6: 'Wisdom 人员能力分析',
        desc6: '基于作业数据量化评估人员能力，构建人才画像，助力合理定岗，提升团队整体效能',
      }
    },
    // 车辆管理场景
    vehicle: {
      banner: {
        title: '车辆管理',
        desc: '车辆管理场景依托智能定位与调度技术，实现车辆位置监控、动态调度、<br/>安全管控，提升车辆运营效率，规范厂区通行管理',
      },
      productList: {
        label1: 'Wisdom车辆实时动态调度',
        desc1: '依托智能系统实现车辆实时调度，优化路径与资源配置，提升运输效率，降低运营成本',
        label2: 'UWB车辆实时定位跟踪管理',
        desc2: '采用 UWB 高精度定位，实时监控车辆位置与轨迹，实现可视化管控，保障厂区行车安全',
        label3: 'Wisdom 车辆效率分析',
        desc3: '智能采集分析车辆运行数据，精准计算车辆OEE，挖掘瓶颈问题，助力提升车辆综合效率',
        label4: 'WISDOM OEE 分析方案',
        desc4: '智能采集分析设备运行数据，精准计算 OEE，挖掘瓶颈问题，助力提升设备综合效率',
      }
    },
    // 行业方案
    industrySet: {
      bannerVehicle: {
        title: '汽车制造行业',
        desc: '聚焦汽车整车生产全流程，提供柔性化智能物流解决方案，覆盖<br/>装配、搬运、仓储等环节，助力产线高效、稳定、智能化升级',
      },
      bannerVehicleAutoParts: {
        title: '汽配行业',
        desc: '针对汽车零部件高精度、多品类特点，打造智能仓储与搬运系<br/>统，实现零部件精准配送，提升生产协同与质量管控水平',
      },
      bannerMachinery: {
        title: '工程机械',
        desc: '赋能大型构件、重载物料作业场景，实现高效转运与仓储，满足<br/>高强度、高可靠的智能制造需求',
      },
      bannerHomeAppliance: {
        title: '白色家电',
        desc: '面向家电整机及零部件生产，提供柔性智能物流方案，优化产线<br/>流转与仓储布局，提升装配与交付效率',
      },
      bannerManufacturing: {
        title: '装备制造',
        desc: '服务高端装备生产全过程，实现大型工件、精密部件智能搬运与<br/>管理，助力企业构建数字化、自动化生产体系',
      },
      bannerBiomedical: {
        title: '生物医疗',
        desc: '遵循医疗行业洁净、合规、可追溯要求，构建智能化仓储与转运<br/>系统，保障药品、耗材安全高效流转',
      },
      bannerDailyChemicals: {
        title: '食品烟草日化',
        desc: '适配食品生产卫生、高效、批量作业特点，提供自动化输送、仓<br/>储、搬运方案，满足安全合规与规模化生产',
      },
      bannerSmelting: {
        title: '冶炼冶金',
        desc: '适配高温、重载、恶劣工况环境，提供高可靠自动化搬运与仓储<br/>设备，保障物料安全转运与连续生产。',
      },
      bannerElectrical: {
        title: '电子电器',
        desc: '面向精密电子元器件，提供高精度、轻柔性智能物流方案，保障<br/>物料安全、高效、无尘化流转与管理',
      },
      bannerLogistics: {
        title: '图书电商及其他物流',
        desc: '满足大订单量、高吞吐、快分拣需求，构建自动化立体库与智能<br/>调度系统，大幅提升出库、入库、配送效率',
      },
      bannerChemical: {
        title: '化工行业',
        desc: '遵循化工行业安全、防爆、合规要求，提供稳定可靠的自动化物<br/>流方案，实现危化品规范存储与智能转运',
      },
      bannerHighspeedTrain: {
        title: '高铁制造',
        desc: '贴合轨道交通高端制造标准，提供高精度、高安全的智能物流装<br/>备，保障关键部件可靠转运与规范化管理',
      },
      bannerSpaceflight: {
        title: '航空航天',
        desc: '服务高精尖零部件制造与装配，采用高精度智能装备，满足严苛<br/>质量、安全与追溯管理要求',
      },
      bannerTransport: {
        title: '交通运输',
        desc: '面向铁路、地铁、机场、港口等场景，提供智能调度、自动化物流<br/>与安防巡检方案，提升运输效率与运营安全，助力交通智慧化升级',
      },
      bannerMunicipal: {
        title: '市政公共服务',
        desc: '适配市政运维、环卫、园区管理、公共安防等场景，以智能装备<br/>实现高效巡检与调度，保障公共服务稳定有序、提质增效',
      },
      bannerMedicalService: {
        title: '医疗服务',
        desc: '贴合医院洁净、合规、高效需求，提供药品耗材自动化转运、智<br/>能巡检等方案，减轻医护负担，保障诊疗流程安全顺畅',
      },
      sceneList: {
        label1: '供应链管理场景',
        desc1: '供应链全程跟踪，风险实时分析预警，精准控库存降成本',
        label2: '原料外仓管理场景',
        desc2: '数字化原料外仓管理，实时追踪库存与物流，降本增效赋能业务拓展',
        label3: '园区管理场景',
        desc3: '均衡运输流量，减少作业波峰波谷，有序入厂，减少供应商车辆等待，按计划入场实现精益管理，全程车辆跟踪预警风险',
        label4: '月台管理场景',
        desc4: '提高月台利用率，智能化调度减少人工干预',
        label5: '装卸车及入库场景',
        desc5: '通过共享装卸车的叉车资源、取消定人定岗，优化作业调度，依托条码智能识别，实现货物自动入库与全流程自动化，降本增效',
        label6: '存储与理货场景',
        desc6: '通过智能IoT设备，实现库存精准管控、高效理货盘点，优化作业流程，降本增效，保障仓储秩序与运营效率',
        label7: '拣选备货场景',
        desc7: '依托智能指引与 IoT 硬件，精准高效完成拣货备货，降本防错，提升仓储作业整体生产力',
        label8: '配送搬运场景',
        desc8: '通过自动化搬运、智能调度与设备协同，实现无人 / 少人化作业，优化路径、减少等待，提升整体物流效率与运营效益',
        label9: '成品外仓管理场景',
        desc9: '实现出库、装卸、运输全流程智能管控，优化资源调度，提升作业效率，保障成品仓储与配送高效有序',
        label10: '生产过程数据管理场景',
        desc10: '生产过程管理场景依托 AIoT 技术实现生产全流程数据可视化，精准管控生产节点，提效降本，有效减少产线停线问题',
        label11: '安全与运营规范管理场景',
        desc11: '依托 IoT 感知与 AI 机器人技术，全面赋能厂区安全管控与运营规范，实现智能监测、风险预警、流程标准化，提升管理效率与安全保障',
        label12: '设备巡检运维管理场景',
        desc12: '依托智能感知与 AI 技术，实现设备状态实时监测、异常预警、高效运维，保障设备稳定运行，降低故障风险',
        label13: '资产管理场景',
        desc13: '通过物联网与智能识别技术，实现资产全生命周期可视化管理，精准盘点、高效追溯，提升资产利用率与管控水平',
        label14: '人员管理场景',
        desc14: '依托智能定位与感知技术，实现人员位置、轨迹、考勤规范化管控，保障作业安全，提升人员管理效率与合规水平',
        label15: '车辆管理场景',
        desc15: '依托智能定位与调度技术，实现车辆位置监控、动态调度、安全管控，提升车辆运营效率，规范厂区通行管理',
      }
    }

  },
  ...zhLocale,
};

export default cn;
